module.exports = __webpack_public_path__ + "static/img/26-1.e5b5de1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/26-1.jpg
// module id = /4th
// module chunks = 0